import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatBadge } from '@angular/material/badge';
import { MatAnchor, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { ActivatedRoute, RouterLink } from '@angular/router';
import {
  ResponseAgreementDto,
  ResponseObjectFieldDto,
  UpdateAgreementDto,
} from '../../../../../../generated/apex-rest';
import { AgreementRestService } from '../../features/object/project/agreement/agreement-rest.service';
import { Autocomplete } from '../../models/autocomplete';
import { snack } from '../../modules/snack.module';
import { AutocompletePickerModule } from '../autocomplete-picker/autocomplete-picker.module';
import { AutocompleteModule } from '../autocomplete/autocomplete.module';
import { BoxModule } from '../box/box.module';
import { ColorPickerModule } from '../color-picker/color-picker.module';
import { TranslateModule } from '../translate/translate.module';
import { ObjectFieldRestService } from './object-field-rest.service';

@Component({
  selector: 'apex-object-fields',
  templateUrl: './object-field.component.html',
  standalone: true,
  imports: [
    TranslateModule,
    AutocompleteModule,
    CommonModule,
    AutocompletePickerModule,
    BoxModule,
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatMenuContent,
    MatMenuTrigger,
    MatBadge,
    ColorPickerModule,
    RouterLink,
    MatAnchor,
    FormsModule,
  ],
  providers: [ObjectFieldRestService, AgreementRestService],
})
export class ObjectFieldComponent implements AfterViewInit, OnChanges, OnInit {
  constructor(
    private route: ActivatedRoute,
    private service: ObjectFieldRestService,
    private agreementRestService: AgreementRestService,
  ) {}

  @Input() objectId: number;
  @Input() agreementId: number;
  @Input() disabled = false;

  objectField: ResponseObjectFieldDto;
  updateAgreementDto: UpdateAgreementDto;
  responseAgreementDto: ResponseAgreementDto;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['objectId'] && !changes['objectId'].isFirstChange()) {
      void this.readAgreementObjectField(this.agreementId);
    }

    if (changes['agreementId'] && !changes['agreementId'].isFirstChange()) {
      void this.readAgreementObjectField(this.agreementId);
    }
  }

  ngAfterViewInit(): void {
    if (this.objectId) {
      void this.readAgreementObjectField(this.agreementId);
    }
  }

  async readObjectFields(objectId: number, objectFieldId: number): Promise<void> {
    if (!objectId || !objectFieldId) {
      return;
    }

    this.objectField = await this.service.readObjectField(objectId, objectFieldId, this.agreementId);
  }

  async readAgreementObjectField(agreementId: number): Promise<void> {
    this.responseAgreementDto = await this.agreementRestService.read(agreementId);

    const objectFieldId = this.responseAgreementDto.ObjectFieldId;

    await this.readObjectFields(this.objectId, objectFieldId);
  }

  ngOnInit(): void {
    this.objectId =
      this.route.snapshot.data?.project?.ParentId ?? this.route.snapshot.data?.project?.id ?? this.objectId;
    this.agreementId = this.route.snapshot.data?.agreement?.id ?? this.agreementId;

    void this.readAgreementObjectField(this.agreementId);
  }

  async updateObjectField(event?: Autocomplete): Promise<void> {
    this.updateAgreementDto = {
      ObjectFieldId: event?.id ?? null,
    };

    try {
      await this.agreementRestService.updateObjectField(this.agreementId, this.updateAgreementDto);

      await this.readAgreementObjectField(this.agreementId);

      snack('Discipline saved');
    } catch (error) {
      snack('Failed to save discipline');
    }
  }
}
